import type { Topic, WorkMonitorItem } from './api'
import { isRunningTopic } from './topicFilterCounts'

export type CodeConversationFilter = 'all' | 'done' | 'live' | 'snooze'

export function codeConversationState(topic: Topic, pendingOutbox = false): 'done' | 'live' | 'snooze' {
  if (topic.is_snoozed) return 'snooze'
  return isRunningTopic(topic, pendingOutbox) ? 'live' : 'done'
}

export function matchesCodeConversationFilter(
  topic: Topic,
  filter: CodeConversationFilter,
  pendingOutbox = false,
): boolean {
  const state = codeConversationState(topic, pendingOutbox)
  if (filter === 'all') return state !== 'snooze'
  if (filter === 'done') return state !== 'snooze' && (state === 'done' || (topic.unread ?? 0) > 0)
  return state === filter
}

export function isLongCodeConversation(
  chatId: string,
  topic: Topic,
  items: readonly WorkMonitorItem[],
  now: number,
  pendingOutbox = false,
): boolean {
  return !topic.closed && codeConversationState(topic, pendingOutbox) === 'live'
    && items.some((item) => item.chat_id === chatId && item.topic_id === topic.id
      && item.started_at <= now - 30 * 60)
}
